import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { ViewConstants } from '../../../app/constants';
import { finalize,catchError } from "rxjs/operators";
import { LoaderService } from '../services/loader.service';
import { SharedDataService } from './../services/shared-data.service';
import { SubSink } from 'subsink';
import { Store } from '@ngrx/store';
import { IAppCoreState } from 'src/app/core/state'; 
import { getUserInfo } from '../state/selectors';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
let requestCount = 0;
/** Pass untouched request through to the next request handler. */
@Injectable()
export class AddHeaderInterceptor implements HttpInterceptor {
  public _subs = new SubSink();

  constructor(
    public loaderService: LoaderService, 
    private readonly router: Router, 
    private readonly sharedService: SharedDataService,
    private readonly _store: Store<IAppCoreState>, 
    private readonly environment: EnvironmentConfiguration) { }

  intercept(req: HttpRequest<any>, next: HttpHandler):
    Observable<HttpEvent<any>> {
    if (!(req.urlWithParams.indexOf("/payments") !== -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1)) {
      requestCount++;
    }
    if ((req.urlWithParams.indexOf("dg.toyota.com") !== -1)) {
      req = this.addIdToken(req);
    }
    //customer view update url.
    const updateWorksheetUrl = this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1 && req.urlWithParams.indexOf("/worksheet") !== -1 && req.urlWithParams.indexOf("/worksheet/view") == -1;
    if (req.urlWithParams.indexOf(ViewConstants.CURRENT_SERVICE_URL) === -1 && req.urlWithParams.indexOf("/comments/") === -1 && req.urlWithParams.indexOf("/price") === -1 && !(req.urlWithParams.indexOf("/payments") === -1 && req.urlWithParams.indexOf("retail-deals/dealers/") === -1 && req.urlWithParams.indexOf("deals/dealers/") === -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1) && !updateWorksheetUrl) {
      if (this.sharedService.relationshipTypeCode === 'LEXUS' && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1) {
        this.sharedService.showLexusLoader = true;
      } else {
        this.sharedService.showLexusLoader = false;
      }
      if(req.urlWithParams.indexOf('/upload')=== -1)
      {this.loaderService.show();}
    }
    //
    // Clone the request
    //
    let clonedReq: HttpRequest<any> = req.clone();

    //
    // If RTI, no need for X-B3-*
    //
    if (clonedReq.url.indexOf(ViewConstants.RTI) > -1) {
      clonedReq = clonedReq.clone({
        headers: clonedReq.headers.delete('X-B3-TraceId')
          .delete('X-B3-SpanId')
      });
    }

    // 
    // Authentication header
    //
    if (this.Should_Add_Authentication_Token_WithBearer(clonedReq.url)) {
      let token: string;
      if (clonedReq.url.indexOf("user/userInfo") !== -1) {
        token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
        clonedReq = clonedReq.clone({ headers: clonedReq.headers.set(ViewConstants.AUTHORIZATION_LOWER_CASE, token) });
      } else {
        this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
          if (userInfo?.hasOwnProperty('isIdToken')) {
            if (userInfo.isIdToken.toLowerCase() == 'true'.toLowerCase()) {
              token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ID_TOKEN_HTTP_CLIENT);
            } else if (userInfo.isIdToken.toLowerCase() == 'false'.toLowerCase()) {
              token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
            }
          } else {
            token = ViewConstants.BEARER + sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
          }
          clonedReq = clonedReq.clone({ headers: clonedReq.headers.set(ViewConstants.AUTHORIZATION_LOWER_CASE, token) });

          if (userInfo?.hasOwnProperty('profile')) {
            // Condition to Invoke the addProfile method
            if (clonedReq.url.indexOf(this.environment.MST_BASE_SERVICE_URL) > -1) {
              clonedReq = this.addProfile(clonedReq, userInfo.profile);
            }
          }

          if (userInfo?.hasOwnProperty('dealer_profile')) {
            if (clonedReq.url.indexOf(this.environment.BASE_SERVICE_URL) > -1) {
              clonedReq = this.addDealerProfile(clonedReq, userInfo.dealer_profile);
            }
          }

        });
      }
    }

    //
    // Condition to Invoke the addCurrentDealer method
    //
    if (clonedReq.url.indexOf(this.environment.BASE_SERVICE_URL) > -1) {
      clonedReq = this.addCurrentDealer(clonedReq);
    }

    //
    // Authentication header for MST. 
    // This method should come at last. there is overlapping condition between the two
    //
    if (this.Should_Add_Authentication_Token_WithoutBearer(clonedReq.url)) {
      let token: string;

      this._subs.sink = this._store.select(getUserInfo).subscribe(userInfo => {
        if (userInfo?.hasOwnProperty('isIdToken')) {
          if (userInfo.isIdToken.toLowerCase() === 'true'.toLowerCase()) {
            token = sessionStorage.getItem(ViewConstants.ID_TOKEN_HTTP_CLIENT);
          } else if (userInfo.isIdToken.toLowerCase() === 'false'.toLowerCase()) {
            token = sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
          }
        } else {
          token = sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT);
        }
        clonedReq = clonedReq.clone({ headers: clonedReq.headers.set(ViewConstants.AUTHORIZATION_LOWER_CASE, token) });

        if (userInfo?.hasOwnProperty('profile')) {
          // Condition to Invoke the addProfile method
          if (clonedReq.url.indexOf(this.environment.MST_BASE_SERVICE_URL) > -1) {
            clonedReq = this.addProfile(clonedReq, userInfo.profile);
          }
        }

        if (userInfo?.hasOwnProperty('dealer_profile')) {
          if (clonedReq.url.indexOf(this.environment.BASE_SERVICE_URL) > -1) {
            clonedReq = this.addDealerProfile(clonedReq, userInfo.dealer_profile);
          }
        }

      });
    }
    if (req.urlWithParams.indexOf("offers/currentPagination") > -1) {
      return next.handle(clonedReq).pipe(
        finalize(() => {
          if (!(req.urlWithParams.indexOf("/payments") !== -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1)) {
            requestCount--;
          }
          if (requestCount === 0 || this.sharedService.getHideLoader()) {
            this.loaderService.hide();
          }
        }),
        catchError((error: HttpErrorResponse) => {
          console.log("This is the Error which occured , below code for continuing the execution of code  to not break the Service Calls" + JSON.stringify(error))
          return of(new HttpResponse({ body: {}, status: 0 }));
        })
      );
    } else {
      return next.handle(clonedReq).pipe(
        finalize(() => {
          if (!(req.urlWithParams.indexOf("/payments") !== -1 && this.router.url.indexOf(ViewConstants.CUSTOMER_VIEW) !== -1)) {
            requestCount--;
          }
          if (requestCount === 0 || this.sharedService.getHideLoader()) {
            this.loaderService.hide();
          }
        })
      );
    }
  }

  //
  // Helper method
  //
  private Should_Add_Authentication_Token_WithBearer(url: string): boolean {
    if (url.indexOf('SignInPolicy') > -1)
      return false;
    return true;
  }
  private Should_Add_Authentication_Token_WithoutBearer(url: string): boolean {
    if (url.indexOf(ViewConstants.GARAGE) > -1)
      return true;
    return false;
  }

  //
  // Intercepting the MST_BASE_SERVICE_URL to add Profile in the header
  //
  private addProfile(url: any, profile: string): any {
    if (url && profile) {
      return url.clone({headers: url.headers.set('x-api-key', profile)});
    } else {
      return url;
    }
  }

  private addIdToken(url: any)
  {
    if (url) {
      return url.clone({headers: url.headers.set('id_token', sessionStorage.getItem(ViewConstants.ACCESS_TOKEN_HTTP_CLIENT))});
    } else {
      return url;
    }
  }

  //
  // Intercepting the BASE_SERVICE_URL to add CurrentDealer in the header
  //
  private addCurrentDealer(url: any): any {
    let dealerCode: any;
    if (this.sharedService?.dealerCode) {
      dealerCode = this.sharedService.dealerCode;
      return url.clone({
        headers: url.headers.set('CurrentDealer', dealerCode)
      });
    } else {
      return url;
    }
  }

  //
  // Intercepting the BASE_SERVICE_URL to add dealerProfile in the header
  //
  private readonly addDealerProfile = (url: any, dealerProfile: string): any => {
    if (url && dealerProfile) {
      return url.clone({headers: url.headers.set('x-api-key', dealerProfile)});
    } else {
      return url;
    }
  }
  

}